import logo from './logo.svg';
import './App.css';
import { Routes, Route, BrowserRouter, Switch } from "react-router-dom";
import Navbar from './components/navbar'
import Footer from './components/footer'
import Home from './components/home'
import Contact from './components/Contact'
import Education from './components/education'
import Work from './components/work'
import Skills from './components/skills'
import Ratings from './components/ratings'
import About from './components/about'
import Project from './components/project'
import Intro from './components/intro'

function App() {
  return (
    <>

    
    

   <BrowserRouter>
        <Switch>
        <Route exact path="/" component={Home}></Route>
      
      <Route path="/intro" component={Intro}></Route>
      <Route path="/about" component={About}></Route>
      <Route path="/Education" component={Education}></Route>
      <Route path="/work" component={Work}></Route>
      <Route path="/project" component={Project}></Route>
      <Route path="/skills" component={Skills}></Route>
      <Route path="/ratings" component={Ratings}></Route>
      <Route path="/contact" component={Contact}></Route>
      <Route path="/navbar" component={Navbar}></Route>
      <Route path="/footer" component={Footer}></Route>
   
    
        </Switch>
        </BrowserRouter>
   
    </>
  );
}

export default App;

